import StatusBadge from "../../generals/StatusBadge";

function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

function DetailRow({ label, value }) {
  return (
    <div className="mt-2 flex flex-row items-start text-gray-700">
      <div className="w-[140px] flex-shrink-0 text-sm mr-2">{label}</div>
      <div className="text-xs font-bold break-words">{formatValue(value)}</div>
    </div>
  );
}

function EmployeeCategoryOverview({ employeeCategory }) {
  if (!employeeCategory) return null;

  return (
    <div className="border-[1px] border-gray-200 rounded-lg p-4 @container">
      <div className="w-full @xl:grid @xl:grid-cols-5 @xl:gap-4">
        <div className="mt-3 @xl:col-span-3">
          <div className="text-gray-600 font-bold text-xl">
            {employeeCategory.name}
          </div>
          <DetailRow label="Id" value={employeeCategory.id} />
          <DetailRow label="Name" value={employeeCategory.name} />
          <DetailRow label="Employee Type" value={employeeCategory.employeeTypeName} />
          <div className="mt-2 flex flex-row items-center text-gray-700">
            <div className="w-[140px] flex-shrink-0 text-sm mr-2">Status</div>
            <StatusBadge
              statusId={employeeCategory.statusId}
              statusName={employeeCategory.statusName}
            />
          </div>
          <DetailRow label="Created By" value={employeeCategory.createdBy} />
          <DetailRow label="Created At" value={employeeCategory.createdAt} />
          <DetailRow label="Last Changed By" value={employeeCategory.lastChangedBy} />
          <DetailRow label="Last Changed At" value={employeeCategory.lastChangedAt} />
        </div>
      </div>
    </div>
  );
}

export default EmployeeCategoryOverview;
